import { Component, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog} from '@angular/material/dialog';
import {MsgDialog} from "../dialog/message-dialog/message-dialog.component";
import {HttpService} from "../services/http/http.service";
@Component({
  selector: 'app-user-area',
  templateUrl: './user-area.component.html',
  styleUrls: ['./user-area.component.scss']
})
export class UserAreaComponent implements AfterViewInit {
  showUserHeader: boolean = true;
  userInfo: any;
  constructor(private router: Router, public dialog: MatDialog, public api: HttpService) { }
  ngAfterViewInit(): void {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.userInfo = sessionStorage.getItem('userInfo');
        this.userInfo = JSON.parse(this.userInfo);
        this.showUserHeader = (this.router.url !== '/');
      }
    });
  }

  logout() {
    this.api.getUrlRedirect().subscribe(data => {
  //    this.api.logout(data.descrizione);
        window.location.href = data.descrizione;
    })
    
  //  this.api.logout().subscribe(value => {
  //     window.location.href = "http://www.google.com/index.html";
//})

    // this.api.logout().subscribe((response: void) => {
		// 	//this.userService.setUserInfo(null);
		// 	window.location.replace("http://www.google.com/index.html");
		// });
  }

  openMsgDialog(): void {
    const dialogRef = this.dialog.open(MsgDialog, {
      data: ''
    });
    dialogRef.afterClosed().subscribe((result: any) => {

    })
  }
}
